import React from "react";
import "./RelatedProducts.scss";
import { ProductCard } from "../../components/ProductCard/ProductCard";
import { useQuery } from "@apollo/react-hooks";
import { RELATED_PRODUCTS, GET_RELATED_PRODUCTS } from "../../queries/relatedProductsQuery";

const RelatedProducts = (props) => {
  const relatedProductsIds = props.relatedProductsIds;
  const productCategoryId = props.productCategory;
  const selectedProductId = props.selectedProductId;
  const singleProduct = props.singleProduct;
  const singleRecipe = props.singleRecipe;

  const { data: categoryData, loading: loadingCategory } = useQuery(RELATED_PRODUCTS, {
    variables: { categoryId: productCategoryId ? [productCategoryId] : [], limit: props.limit },
    skip: !singleProduct,
  });

  const { data: recipeData, loading: loadingRecipe } = useQuery(GET_RELATED_PRODUCTS, {
    variables: { productId: relatedProductsIds },
    skip: !singleRecipe || !relatedProductsIds || relatedProductsIds.length === 0,
  });

  if (loadingCategory || loadingRecipe) return <div></div>;

  const relatedProducts = categoryData?.products?.nodes || [];
  const recipesProducts = recipeData?.products?.nodes || [];

  const filteredProducts = singleProduct
    ? relatedProducts.filter((item) => {
        const selectedIds = Array.isArray(selectedProductId)
          ? selectedProductId.map((id) => id.toString())
          : [selectedProductId?.toString()];
        return !selectedIds.includes(item.id?.toString());
      })
    : [];

  return (
    <div className="RelatedProducts">
      <div className="products">
        {singleRecipe && recipesProducts.map((product) => <ProductCard key={product.id} product={product} />)}
        {singleProduct && filteredProducts.map((product) => <ProductCard key={product.id} product={product} />)}
      </div>
    </div>
  );
};

export default RelatedProducts;
